import styled from "styled-components";

import { colorsPalettes, mixins, fonts, $robotoFontFamily } from "@similarweb/styles";
import { SliderHeader, SliderTitle, SliderDescription } from "@similarweb/ui-components";

export const StyledRangeFilter = styled.div<{ isInitialState: boolean }>`
    padding: 0 0 2px 9px;

    ${SliderHeader} {
        margin-bottom: 13px;
    }

    ${SliderTitle} {
        ${mixins.setFont({
            $color: colorsPalettes.carbon["400"],
            $size: 12,
            $weight: 400,
            $family: fonts.$dmSansFontFamily,
        })};
        letter-spacing: normal;
        line-height: 16px;
        user-select: none;
        margin-left: -9px;
    }

    ${SliderDescription} {
        font-weight: ${({ isInitialState }) => (isInitialState ? 400 : 500)};
        font-size: 12px;
        color: ${({ isInitialState }) => (isInitialState ? colorsPalettes.carbon["400"] : colorsPalettes.blue["400"])};
        line-height: 20px;
        user-select: none;
        font-family: ${$robotoFontFamily};
    }

    .rc-slider {
        width: 241px;
        margin-right: 11px;

        .rc-slider-handle {
            width: 22px;
            height: 22px;
            margin-top: -11px;
        }

        .rc-slider-track,
        .rc-slider-step,
        .rc-slider-rail {
            height: 4px;
            margin-top: -2px;
            margin-left: -8px;
            width: 262px;
        }
    }

    .rc-slider-disabled {
        .rc-slider-step {
            background-color: ${colorsPalettes.carbon["100"]};
        }
    }
`;
